import { useState } from "react";
import { editorColors as colors } from "../../styles/theme";

export function ToolBtn({ icon: Icon, label, active, onClick, disabled, small }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      title={label}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: small ? 28 : 32,
        height: small ? 28 : 32,
        borderRadius: 5,
        border: "none",
        background: active
          ? colors.accentDim
          : hover
            ? "rgba(255,255,255,0.05)"
            : "transparent",
        color: active
          ? colors.accent
          : disabled
            ? colors.textSecondary
            : colors.textSecondary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all 0.12s",
      }}
    >
      <Icon size={small ? 14 : 16} />
    </button>
  );
}

export function ToolDivider() {
  return (
    <div
      style={{
        width: 1,
        height: 20,
        background: colors.border,
        margin: "0 4px",
      }}
    />
  );
}
